import React from "react";
import { Container, NarrowBody } from "components/generic/layout";
import { Input, Formik } from "components/generic/form/formik";
import { Title, Label, ErrorMultiple } from "components/generic/form/service";
import { Button } from "components/generic/kit";
import { FieldArray } from "formik";

export default ({
  initialValues,
  validationSchema,
  onSubmit,
  sendInviteApi,
  errors,
  title
}) => (
  <Container>
    <NarrowBody>
      <Title>{title}</Title>
      <Formik
        initialValues={initialValues}
        onSubmit={values => onSubmit(values)}
        validationSchema={validationSchema}
      >
        {({ values, handleSubmit }) => (
          <FieldArray name="emails">
            {arrayHelpers => (
              <form onSubmit={handleSubmit}>
                {!!sendInviteApi.error && (
                  <div className="mb3 measure">
                    <ErrorMultiple errors={sendInviteApi.error} />
                  </div>
                )}
                {values.emails &&
                  values.emails.length > 0 &&
                  values.emails.map((emails, index) => (
                    <div className="db" key={index}>
                      <div className="w-75 w-80-ns dib">
                        <Label title="Email">
                          <Input
                            type="email"
                            placeholder="your friend's email"
                            name={`emails.${index}.invitee_email`}
                          />
                        </Label>
                      </div>
                      <div className="mt3 absolute center dib">
                        <div className="pa3 mt2">
                          <Button
                            type="button"
                            size="small"
                            onClick={() => arrayHelpers.remove(index)}
                          >
                            remove
                          </Button>
                        </div>
                      </div>
                    </div>
                  ))}
                <div className="mt3 mb3">
                  <Button
                    type="button"
                    color="gray"
                    size="large"
                    onClick={() => arrayHelpers.push("")}
                  >
                    + Add another
                  </Button>
                </div>
                <div className="w-60-ns db center">
                  <Button
                    color="white"
                    type="submit"
                    disabled={sendInviteApi.isFetching}
                  >
                    Send Invitation
                  </Button>
                </div>
              </form>
            )}
          </FieldArray>
        )}
      </Formik>
    </NarrowBody>
  </Container>
);



// WEBPACK FOOTER //
// ./src/components/common/referral/SendReferral/View.js